import { CTASectionProps } from "@components/alternatives/AlternativesCTASection";
import AwardsSection from "@components/new-ui/AwardsSection";
import ClientLogos from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import Herosection, { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import ProductSection, { Product } from "@components/new-ui/IndustriesSection/ProductSection";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import ProblemSectionCard, { ProblemSection } from "@components/solution/problemSectionCard";
import { BlueCardCTASection, GreyCardCTASection } from "@components/solution/solutionCTASection";
import React from "react";

const herosectionData: HerosectionProps = {
    chipTitle: "GALLABOX FOR MARKETING",
    title: "Stuck chasing leads manually?",
    description: "Generate 90% more leads and drive marketing qualified pipelines for better conversions. Zero coding. All via WhatsApp automation.",
    primaryButtonText: "Start free trial",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/marketing/hero-image.png",
    enableDemoButton: true,
    demoBtnText: "Book a Demo",
    demoLink:
        "https://crm.zoho.in/bookings/GallaboxDemoandOnboardingSupport?rid=e017ab236bd0f95d0928435833b5a67cf42890afe6496cd7606c362e43d4ee64593a4f966fd6f97f07dfa687bc10ccdfgid088ed678da7fd14a47fd11e0b6ac335685cfe4d580f6b562b2cea9ccbb2355c5",
};

const featureInfo1: FeatureInfo = {
    mainTitle: "Instant engagement tools",
    subtitle2: "Turn interest into action, instantly.",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/marketing/instant-tool.png",
    featureInfoList: ["Launch CTWA ads to connect at peak intent.", "Assign, track, and resolve chats via shared dashboard.", "Ensure prompt, personalized responses every time."],
};

const featureInfo2: FeatureInfo = {
    mainTitle: "Automated nurturing",
    subtitle2: "Guide leads from “maybe” to “yes”.",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/marketing/automated-nurturing.png",
    featureInfoList: ["Schedule drip campaigns and broadcasts instantly.", "Guide audiences from discovery to purchase.", "Automate follow-ups to reduce manual effort."],
};
const featureInfo3: FeatureInfo = {
    mainTitle: "Smart lead qualifier",
    subtitle2: "Chatbots that sell, not just chat.",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/marketing/lead-qualifier.png",
    featureInfoList: ["Qualify leads via WhatsApp chatbots.", "Showcase products with interactive demos.", "Process payments directly in chat."],
};
const featureInfo4: FeatureInfo = {
    mainTitle: "AI efficiency boost",
    subtitle2: "Swap busywork for big wins",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/marketing/ai-efficiency-boots.png",
    featureInfoList: ["Generate instant answers with Gen AI.", "Manage FAQs via one-click quick replies.", "Free teams to focus on strategic growth."],
};

const ProblemSectionData: ProblemSection = {
    maintitle: "Are hidden tech gaps sabotaging your marketing growth?",
    problemSectionCard: [
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/group-call.svg",
            title: "Cutting through the clutter",
            description: "Generic emails and social posts lack personalization, failing to engage audiences in a crowded digital space.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/toolbar-box.svg",
            title: "Juggling multiple tools and data",
            description: "Scattered data and inconsistent messaging across platforms dilute campaign impact, missing key opportunities.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/group-chat.svg",
            title: "Real-time engagement",
            description: "Delays in data hinder quick adjustments; instant metrics on engagement and conversions are crucial for making timely, data-driven decisions.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/personalisation.svg",
            title: "Personalized marketing at scale",
            description: "Mass outreach sacrifices personalization, while manual processes hinder scalability and proactive relationship-building.",
        },
    ],
};

const marketingProductData: Array<Product> = [
    {
        title: "Accelerate lead generation",
        description: "Capture and nurture quality leads effortlessly with Gallabox’s WhatsApp automation.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/leads.svg",
        externalLink: "",
    },
    {
        title: "Personalize your messages at scale",
        description: "Craft unique and segmented campaigns that resonate with your audience.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/filter.svg",
        externalLink: "",
    },
    {
        title: "Automate lead qualification",
        description: "Instantly hit your monthly targets with intelligent AI chatbots that streamline lead qualification.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/settings.svg",
        externalLink: "",
    },
    {
        title: "Auto-manage your campaigns",
        description: "Effortlessly handle outreach with automated responses, templates, and smart scheduling.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/campaign.svg",
        externalLink: "",
    },
    {
        title: "Boost branding efforts",
        description: "Leverage WhatsApp to enhance brand awareness through two-way communication with your audience.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/boost-branding.svg",
        externalLink: "",
    },
    {
        title: "Integrate with your tech stack",
        description: "Effortlessly connect your CRM and marketing automation tools for unified, seamlessly automated workflows.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/integrate.svg",
        externalLink: "",
    },
    {
        title: "Track analytics in real time",
        description: "Monitor live chats (open, resolved, channel-specific, and bot-initiated) with dynamic graphs for data-backed decisions.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/data-analysis.svg",
        externalLink: "",
    },
    {
        title: "Amplify engagement with rich media",
        description: "Use high-quality images, videos, GIFs, and interactive buttons to capture attention and drive more clicks effortlessly.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/profile-image.svg",
        externalLink: "",
    },
];

const greyCardCTAContent: CTASectionProps = {
    content: "Gallabox powers Pickyourtrail's WhatsApp marketing success",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/marketing/pickyourtrail.png",
    imgAlt: "wa-gallabox",
    btnText: "Read the story",
};

const blueCardCTAContent: CTASectionProps = {
    content: "Drive purposeful automation on WhatsApp with Gallabox",
    imageUrl: "https://assets.gallabox.com/gb-home/solution/sales/sales-cta.png",
    imgAlt: "wa-gallabox",
    btnText: "Sign up today!",
};

const sales: React.FC = () => {
    return (
        <NewLayout
            title={"WhatsApp Business Solution for Marketing Teams | Gallabox"}
            description={"Boost engagement and drive more leads with Gallabox’s WhatsApp Business solution for marketing teams—automate and scale campaigns with ease."}
            canonical="https://gallabox.com/solutions/marketing-teams"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/solution/enterprises/solution-enterprises-og.png" }}
            schema={{
                heroOrOgImageAlt: "solutions-marketing-teams-image",
                heroOrOgImageDescription: "Stuck chasing leads manually?",
                heroOrOgImageUrl: "https://assets.gallabox.com/gb-home/solution/marketing/hero-image.png",
                softwareFeatureName: "marketing-teams",
            }}
        >
            <Herosection herosection={herosectionData} />
            <section className={`${container_classname} my-10`}>
                <h3 className="text-center text-lg font-normal py-5">Trusted by 10,000+ businesses</h3>
                <ClientLogos />
            </section>

            <ProblemSectionCard problemSection={ProblemSectionData} />
            <section className="mx-5">
                <BlueCardCTASection ctaContent={blueCardCTAContent} />
            </section>

            <h5 className={`${container_classname} md:text-7xl text-5xl mt-20`} style={{ fontFamily: "Degular Display" }}>
                Upgrade your tech stack with WhatsApp automation to boost campaigns
            </h5>
            <FeatureInfoCard {...featureInfo1} />
            <FeatureInfoCard {...featureInfo2} />
            <FeatureInfoCard {...featureInfo3} />
            <FeatureInfoCard {...featureInfo4} />

            <ProductSection productCardData={marketingProductData} title="Key benefits of integrating Gallabox into your MarTech stack" />
            <div className={`${container_classname} my-20`}>
                <h5 className="text-6xl mb-10">Customer story</h5>
            </div>
            <section className="mx-5">
                <GreyCardCTASection ctaContent={greyCardCTAContent} />
            </section>

            <IntegrationSection isLight={true} />
            <AwardsSection />
            <CTASection title="Turn connections into conversions" description="Be among the first to ride the WhatsApp automation wave" />
        </NewLayout>
    );
};

export default sales;
